// @spec AI-STR-012
// Extraction review page route

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ExtractionReviewPage } from '@/features/ai/extractions';

// Search params validation
const extractSearchSchema = z.object({
  extractionId: z.string(),
});

export const Route = createFileRoute('/_authenticated/ai/documents/$documentId/extract')({
  validateSearch: extractSearchSchema,
  component: ExtractionReviewRoute,
});

function ExtractionReviewRoute() {
  const { documentId } = Route.useParams();
  const { extractionId } = Route.useSearch();

  return <ExtractionReviewPage documentId={documentId} extractionId={extractionId} />;
}
